import React from 'react'
import { Box, Button } from '@mui/material'
import { Item } from '../../common/snippets'
import * as sx from '../../common/stylesInline/report_daily_branch'
import Modal from '../../common/modal'
import { useTranslation } from '../../../i18n/I18nProvider'

const DestinationChangeRemarkMode = ({updateModal,setTextAreaValue,setShowModel,updateSendetReceiverDetails}) => {
    const { translations } = useTranslation()
    const au = translations?.adminUpdate || {}

    const handleSave =()=>{
        updateSendetReceiverDetails()
    }
    const handleRemark =(value)=>{
       setTextAreaValue(value)
    }
  return (
    <Modal headTxt={au.destinationChangeRemark || 'Destination Change Remark'} width={'50%'} updateModal={updateModal}>
            <Box style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'column', margin: '15px' }}>
                <Box sx={{ display: 'inline-flex', padding: '0% 0px', height: '100px', marginBottom: '10px' }}>
                    <textarea
                        className="ticket-textarea"
                        id="rulesInput"
                        name="rulesInput"
                        onChange={(e) => handleRemark(e.target.value)}
                        rows="10"
                        placeholder={au.typeYourRemarksHere || 'Type Your Remarks here...'}
                        style={{
                            width: '100%',
                            boxSizing: 'border-box',
                            borderRadius: '6px',
                            borderColor: '#00000026',
                            padding: '15px',
                            fontFamily: 'Roboto',
                            fontSize: '14px',
                            fontWeight: '500',
                            color: '#444444',
                        }}
                    />
                </Box>
                <Item sx={sx.itemsx} style={{ textAlign: 'right' }}>
                    <Button variant="contained" className="go click-button" onClick={handleSave}>
                        {au.save || 'SAVE'}
                    </Button>
                </Item>
            </Box>
        </Modal>
  )
}

export default DestinationChangeRemarkMode